import React, { createContext, useContext, useMemo } from 'react';
import { FindSuggestionOptions } from './suggestionFieldMatcher';

export type SuggestionAutocomplete = {
  // the suggestion-supported fields to offer for the label being typed into a
  // DE2 template item. The default offers none: suggestions are off for the
  // review, or its features are still loading
  findSuggestionOptions: FindSuggestionOptions;
};

export const noSuggestionOptions: FindSuggestionOptions = () => [];

const SuggestionAutocompleteContext = createContext<SuggestionAutocomplete>({
  findSuggestionOptions: noSuggestionOptions,
});

export const useSuggestionAutocomplete = (): SuggestionAutocomplete =>
  useContext(SuggestionAutocompleteContext);

type Props = {
  findSuggestionOptions: FindSuggestionOptions;
  children: React.ReactNode;
};

export const SuggestionAutocompleteProvider = ({
  findSuggestionOptions,
  children,
}: Props): JSX.Element => {
  const value = useMemo(() => ({ findSuggestionOptions }), [
    findSuggestionOptions,
  ]);

  return (
    <SuggestionAutocompleteContext.Provider value={value}>
      {children}
    </SuggestionAutocompleteContext.Provider>
  );
};
